function formsInitializer() {
  var initFocusableInputs = function () {
    $('.focusable').on('focus', function () {
      $(this).parent().addClass('has-focus');
    });

    $('.focusable').on('focusout', function () {
      if ($(this).val().length === 0) {
        $(this).parent().removeClass('has-focus');
      }
    });
  }

  var initFormsBehaviour = function () {
    initFocusableInputs();
  }

  return {
    initFormsBehaviour: initFormsBehaviour
  }
}


(function ($, document, window) {
  $(document).ready(function () {
    var fi = new formsInitializer();
    fi.initFormsBehaviour();
  });
} (jQuery, document, window));